import { useContext, useEffect, useState } from "react";
import { PortalContext } from "../Portal/index.js";
const useShadowRootElement = (id)=>{
    const [element, setElement] = useState(null);
    const portalContext = useContext(PortalContext);
    const rootId = null == portalContext ? void 0 : portalContext.widgetContainerId;
    const elementId = id || (null == portalContext ? void 0 : portalContext.widgetLayoutContainer);
    useEffect(()=>{
        if (!elementId || !rootId) return;
        const shadowRootWrapper = document.getElementById(rootId);
        const root = null == shadowRootWrapper ? void 0 : shadowRootWrapper.shadowRoot;
        const elementInShadow = null == root ? void 0 : root.getElementById(elementId);
        if (elementInShadow) setElement(elementInShadow);
    }, [
        elementId,
        rootId
    ]);
    return element;
};
export { useShadowRootElement };
